export default function MatchCards({ yellow = 0, red = 0, direction = 'home' }) {
  const showYellow = Number(yellow) !== 0;
  const showRed = Number(red) !== 0;

  if (!showYellow && !showRed) {
    return null;
  }

  const yellowCard = showYellow ? (
    <span 
      className="bg-yellow-400 flex text-black text-xs h-4 w-3 rounded justify-center items-center" 
      title="Thẻ Vàng"
    >
      {yellow}
    </span>
  ) : null;

  const redCard = showRed ? (
    <span 
      className="bg-red-600 flex text-white text-xs h-4 w-3 rounded justify-center items-center" 
      title="Thẻ Đỏ"
    >
      {red}
    </span>
  ) : null;

  return (
    <div className="flex gap-1 items-center shrink-0">
      {direction === 'home' ? (
        <>
          {yellowCard}
          {redCard}
        </>
      ) : (
        <>
          {redCard}
          {yellowCard}
        </>
      )}
    </div>
  );
}